exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".special-edition-tip-modal-content .tips[data-v-7232da1e]{margin-bottom:24px}.special-edition-tip-modal-content .tips-content-link[data-v-7232da1e]{color:#1890ff;cursor:pointer}.special-edition-tip-modal-content .form-actions[data-v-7232da1e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:10px}", ""]);

// exports
